// src/pages/IncidentsPage.jsx
// The Response Suite blocks iframes (X-Frame-Options), so this is a launcher page.
import React from "react";

const MODULES = [
  { icon: "🎣", label: "Phishing Purge",      desc: "Search and permanently delete phishing emails across all 2,113 mailboxes" },
  { icon: "📬", label: "Mailbox Delegation",  desc: "Grant and auto-revoke mailbox access with timed expiry" },
  { icon: "🔍", label: "Exfiltration Audit",  desc: "Scan sent items for external forwarding and data exfiltration signals" },
  { icon: "📨", label: "Message Trace",        desc: "Trace email delivery across the org via Exchange Online" },
  { icon: "🧠", label: "Threat Intelligence", desc: "Cross-reference senders and domains against historical audit data" },
  { icon: "🔒", label: "User Containment",     desc: "Revoke sessions, reset MFA, and disable compromised accounts" },
  { icon: "📋", label: "Audit Log",            desc: "View and export all incident response actions and purge history" },
];

export function IncidentsPage() {
  return (
    <div style={{
      flex: 1, overflowY: "auto", padding: "32px 40px",
      background: "var(--bg)",
    }}>
      {/* Header */}
      <div style={{ marginBottom: 32 }}>
        <div style={{
          display: "inline-flex", alignItems: "center", gap: 8,
          background: "var(--primary-dim)", border: "1px solid rgba(0,178,227,0.3)",
          borderRadius: 6, padding: "3px 12px", marginBottom: 14,
          fontSize: 10, color: "var(--primary)", fontFamily: "var(--mono)", letterSpacing: ".08em",
        }}>
          🛡 INCIDENT RESPONSE
        </div>
        <div style={{ fontSize: 22, fontWeight: 800, color: "var(--tx)", marginBottom: 8 }}>
          IMA Response Suite
        </div>
        <div style={{ fontSize: 13, color: "var(--tx3)", lineHeight: 1.7, maxWidth: 560 }}>
          Full phishing incident response toolset for The IMA Group's 2,100+ Microsoft 365 mailboxes.
          Sign in with your <strong style={{ color: "var(--tx2)" }}>@theimagroup.com</strong> account.
        </div>
      </div>

      {/* Launch button */}
      <a
        href="https://incidentresponse.theimagroup.com"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          display: "inline-flex", alignItems: "center", gap: 10,
          padding: "13px 28px", marginBottom: 40,
          background: "var(--ima-blue)", borderRadius: "var(--r)",
          color: "#fff", fontFamily: "var(--sans)", fontSize: 13, fontWeight: 700,
          textDecoration: "none", transition: "opacity .15s",
        }}
        onMouseOver={e => e.currentTarget.style.opacity = ".85"}
        onMouseOut={e => e.currentTarget.style.opacity = "1"}
      >
        Open Incident Response Suite ↗
      </a>

      {/* Module grid */}
      <div style={{ marginBottom: 16, fontSize: 11, color: "var(--tx3)", fontFamily: "var(--mono)", letterSpacing: ".05em" }}>
        AVAILABLE MODULES
      </div>
      <div style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
        gap: 12,
      }}>
        {MODULES.map(m => (
          <a
            key={m.label}
            href="https://incidentresponse.theimagroup.com"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "flex", alignItems: "flex-start", gap: 14,
              padding: "16px 18px",
              background: "var(--s1)", border: "1px solid var(--b1)",
              borderRadius: 10, textDecoration: "none",
              transition: "border-color .15s, background .15s",
            }}
            onMouseOver={e => {
              e.currentTarget.style.borderColor = "rgba(0,178,227,0.4)";
              e.currentTarget.style.background = "var(--s2)";
            }}
            onMouseOut={e => {
              e.currentTarget.style.borderColor = "var(--b1)";
              e.currentTarget.style.background = "var(--s1)";
            }}
          >
            <span style={{ fontSize: 24, lineHeight: 1, flexShrink: 0 }}>{m.icon}</span>
            <div>
              <div style={{ fontSize: 12, fontWeight: 700, color: "var(--tx)", marginBottom: 4 }}>
                {m.label}
              </div>
              <div style={{ fontSize: 11, color: "var(--tx3)", lineHeight: 1.5 }}>
                {m.desc}
              </div>
            </div>
          </a>
        ))}
      </div>

      {/* Footer note */}
      <div style={{
        marginTop: 32, padding: "12px 16px",
        background: "var(--s2)", border: "1px solid var(--b1)",
        borderRadius: 8, fontSize: 11, color: "var(--tx3)", lineHeight: 1.6,
      }}>
        <strong style={{ color: "var(--tx2)" }}>Note:</strong> The Response Suite opens in a new tab.
        It uses its own Microsoft sign-in — if you're already signed in at{" "}
        <code style={{ fontFamily: "var(--mono)", fontSize: 10 }}>incidentresponse.theimagroup.com</code>,
        you'll go straight in.
      </div>
    </div>
  );
}
